import { createReducer } from 'redux-starter-kit';
import { adminTeamsActions } from '../actions';
import getStdDbModelReduxMapping from './std-db-model-reducers';

export const adminTeamsInitialState = {};

const adminTeamsReducer = createReducer(
  adminTeamsInitialState,
  getStdDbModelReduxMapping(adminTeamsActions),
);

export default adminTeamsReducer;
